import { render, staticRenderFns } from "./ModalProveedores.vue?vue&type=template&id=05e29ee8"
import script from "./ModalProveedores.vue?vue&type=script&lang=js"
export * from "./ModalProveedores.vue?vue&type=script&lang=js"
import style0 from "./ModalProveedores.vue?vue&type=style&index=0&id=05e29ee8&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports